import { useCallback, useState } from 'react'

function useModalState() {
  const [isOpen, setIsOpen] = useState(false)
  const openModal = useCallback(() => setIsOpen(true), [])
  const closeModal = useCallback(() => setIsOpen(false), [])
  const toggleModal = useCallback(() => setIsOpen((prevState) => !prevState), [])

  return {
    isOpen,
    openModal,
    closeModal,
    toggleModal,
  }
}

export default useModalState
